// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"61ea0917","703":"0c51b009","787":"06ec4088"}[chunkId] + ".chunk.js";
};